import { IUser } from '@root-gipro/modules/AdminPanel/interfaces/user'
import { Modal } from '@root-gipro/shared/Modal/Modal'
import React, { FC } from 'react'
import styled from 'styled-components'

interface IModalDeleteSolution {
	anchorEl: (EventTarget & HTMLElement) | null | undefined
	setAnchorEl(event: HTMLElement): void
	solution?: any
	handleDelete(): void
}
const TitleModal = styled.h2`
	display: flex;
	justify-content: center;
	margin: 0 0 20px 0;
`
const ContainerModal = styled.div`
	margin: 10px 0;
`

const ModalDeleteSolution: FC<IModalDeleteSolution> = ({ anchorEl, setAnchorEl, handleDelete, solution }) => {
	const handleClose = () => {
		setAnchorEl(null!)
	}

	const buttons = {
		PrimaryBtn: {
			handler: () => {
				handleDelete()
				setAnchorEl(null!)
			},
			value: 'Удалить',
		},

		SecondaryBtn: {
			handler: handleClose,
			value: 'Отмена',
		},
	}
	
	return (
		<Modal setAnchorEl={setAnchorEl} anchorEl={anchorEl} buttonOptions={buttons}>
			<TitleModal>Удаление тех. решения</TitleModal>
			<ContainerModal>
				Подтвердить удаление тех. решения:
				<ContainerModal>Шифр: {solution.techParamCode}</ContainerModal>
				<ContainerModal>Название: {solution?.techParamName}</ContainerModal>
			</ContainerModal>
		</Modal>
	)
}

export default ModalDeleteSolution
